import { AssessExperienceStage } from './AssessExperienceStage'
import { buildAnswers } from './buildAnswers'
import { QuestionsProviderV1 } from './QuestionsProviderV1'
import { InitialScreen } from './InitialScreen'
import { SophisticatedTest } from './analysis-form-sophisticated/SophisticatedTest'
import { steps as sophisticatedSteps } from './analysis-form-sophisticated/steps'
import { useSophisticatedTestStore } from './analysis-form-sophisticated/useSophisticatedTestStore'
import { steps as baseSteps } from './analysis-form-unsophisticated/steps/base'
import { steps as experiencedSteps } from './analysis-form-unsophisticated/steps/experienced'
import { steps as simulationSteps } from './analysis-form-unsophisticated/steps/investor-simulation'
import { UnsophisticatedTest } from './analysis-form-unsophisticated/UnsophisticatedTest'
import { useUnsophisticatedTestStore } from './analysis-form-unsophisticated/useUnsophisticatedTestStore'

const inexperiencedSteps = [...baseSteps, ...simulationSteps]

export const analysisVersion1 = {
  InitialScreen,
  AssessExperienceStage,
  SophisticatedTest,
  UnsophisticatedTest,
  steps: {
    sophisticated: sophisticatedSteps,
    experienced: [...experiencedSteps, ...inexperiencedSteps],
    inexperienced: inexperiencedSteps,
  },
  useSophisticatedTestStore,
  useUnsophisticatedTestStore,
  QuestionsProvider: QuestionsProviderV1,
  buildAnswers,
}
